import {h, Fragment} from "preact"
import { formatDate } from '../helpers'

export default ({ item }) => {
    if(!item.url || !item.imageUrl || !item.title) return;

    return (
        <div class="ns-article-item">
            <a href={item.url}>
                <div class="ns-article-image-wrap">
                    <img src={item.imageUrl} alt={item.title} />
                </div>
                <div class="ns-article-info">
                    <div class="ns-article-title">{item.title}</div>
                    <div class="ns-article-date">{formatDate(item.lastmod)}</div>
                </div>
            </a>
        </div>
    )
}
